export enum SimulationSetValidationErrorType {
  DuplicateMnemonic = 'duplicate mnemonic',
  InvalidMnemonic = 'invalid mnemonic',
  MnemonicAlreadyInDB = 'mnemonic in db',
  MissingDataset = 'missing dataset'
}

export interface SimulationSetValidationError {
  id?: string;
  type: SimulationSetValidationErrorType;
  message?: string;
}
